import React from 'react';
import Icon from '../../../components/AppIcon';

const QuickSuggestions = ({ onSuggestionClick, isVisible }) => {
  const suggestions = [
    {
      id: 1,
      text: "حقوق کار و استخدام",
      icon: "Briefcase",
      category: "employment"
    },
    {
      id: 2,
      text: "قراردادها و معاملات",
      icon: "FileText",
      category: "contracts"
    },
    {
      id: 3,
      text: "حقوق خانواده",
      icon: "Heart",
      category: "family"
    },
    {
      id: 4,
      text: "املاک و مستغلات",
      icon: "Home",
      category: "property"
    },
    {
      id: 5,
      text: "حقوق جزایی",
      icon: "Shield",
      category: "criminal"
    },
    {
      id: 6,
      text: "حقوق تجاری",
      icon: "TrendingUp",
      category: "commercial"
    }
  ];

  if (!isVisible) return null;

  return (
    <div className="px-4 py-3 bg-card border-t border-border animate-in slide-in-from-bottom-3 duration-300">
      <div className="mb-3">
        <h3 className="text-sm font-medium text-card-foreground mb-1">موضوعات پرطرفدار</h3>
        <p className="text-xs text-muted-foreground">روی هر موضوع کلیک کنید تا سوال خود را شروع کنید</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
        {suggestions?.map((suggestion) => (
          <button
            key={suggestion?.id}
            onClick={() => onSuggestionClick(suggestion?.text)}
            className="flex items-center p-3 text-sm font-medium text-card-foreground bg-muted hover:bg-muted/80 rounded-lg transition-smooth focus-ring group"
          >
            <Icon 
              name={suggestion?.icon} 
              size={16} 
              className="ml-2 text-primary group-hover:text-primary/80" 
            />
            <span className="truncate">{suggestion?.text}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickSuggestions;